import { forwardRef, ReactElement, Ref, useEffect } from "react";
import { ControllerProps, FieldValues, useController } from "react-hook-form";
import SelectInput, { SelectInputProps } from "./SelectInput";

type SelectFormInputProps<T extends FieldValues> = Omit<
  ControllerProps<T>,
  "render"
> & {
  input: SelectInputProps;
};

const SelectFormInput = <T extends FieldValues>({
  name,
  rules,
  control,
  input,
  ...rest
}: SelectFormInputProps<T>) => {
  const { field } = useController({ name, control, rules, ...rest });

  useEffect(() => {
    if (input.items?.length === 1) {
      field.onChange(input.items[0].key);
    }
  }, [input.items, input.items?.length]); // eslint-disable-line

  return (
    <SelectInput
      {...field}
      {...input}
      placeholder={input.items?.length === 1 ? undefined : input.placeholder}
      onChange={(value) => {
        field.onChange(value);
        input.onChange && input.onChange(value);
      }}
    />
  );
};

export default forwardRef(SelectFormInput) as <T extends FieldValues>(
  props: SelectFormInputProps<T> & { ref?: Ref<HTMLSelectElement> }
) => ReactElement;
